export function mergeOverride(override) {
  return function (oper) {
    const update = override ? override[oper.key] : null;
    if (update) {
      return { ...oper, ...update };
    }
    return oper;
  };
}
